import { render } from "./GlobalErrorHandler.vue?vue&type=template&id=97df99dc"
import script from "./GlobalErrorHandler.vue?vue&type=script&lang=js"
export * from "./GlobalErrorHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__